<template>
  <confirm-dialog
    :title="payload.title"
    ref="confirmModal"
    @ok="onOk"
    @cancel="onCancel"
    :ok-title="payload.okTitle || 'Yes'"
    :cancel-title="payload.cancelTitle || 'No, cancel'"
    :hide-header="!payload.title"
    :ok-variant="payload.variant || 'danger'"
  >
    {{ payload.body }}
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import events from '@/constants/events'
import EventBusMixin from '@/mixins/EventBusMixin'

/**
 * This is global Confirmation dialog container which can be triggered by calling the function showConfirm - src/utils/showConfirm.js
 * Payload accepts below properties
 * - body
 * - title
 * - variant
 * - callback
 * - cancelCallback
 * - okTitle
 * - cancelTitle
 */
export default {
  name: 'DialogContainer',
  mixins: [EventBusMixin],
  components: { ConfirmDialog },
  data() {
    return {
      payload: {}
    }
  },
  mounted() {
    this.listenToEventBus(events.CONFIRM_DIALOG, payload => {
      this.payload = payload
      this.$nextTick(() => this.$refs.confirmModal.show())
    })
  },
  methods: {
    onOk() {
      this.payload.callback?.()
    },
    onCancel() {
      this.payload.cancelCallback?.()
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped></style>
